import type { TicketTechnik } from "./ticketTypen";
import { installiereTelefonieSpuren } from "./telefonieSpuren";

/**
 * Ringpuffer der letzten 20 Konsolenfehler und fehlgeschlagenen API-Aufrufe —
 * landet als `technik` im Ticket (nur für Admin/GF/GL sichtbar). Bewusst OHNE
 * Request-/Response-Inhalte: nur Methode, Pfad, Status.
 */
const MAX = 20;
const MAX_TEXT = 500;
type Spur = { art: "konsole" | "api"; zeit: string; text: string };
let puffer: Spur[] = [];
let installiert = false;

export function merkeSpur(art: Spur["art"], text: string): void {
  // ResizeObserver-Rauschen ignorieren — benigne Browser-Meldungen
  if (String(text).includes("ResizeObserver loop")) return;
  puffer.push({ art, zeit: new Date().toISOString(), text: String(text).slice(0, MAX_TEXT) });
  if (puffer.length > MAX) puffer = puffer.slice(-MAX);
}

export function spurenSchnappschuss(): TicketTechnik {
  const hatFenster = typeof window !== "undefined";
  return {
    browser: typeof navigator !== "undefined" ? navigator.userAgent : undefined,
    fenster: hatFenster ? { breite: window.innerWidth, hoehe: window.innerHeight } : undefined,
    appVersion: String(import.meta.env.VITE_APP_VERSION ?? "dev"),
    spuren: puffer.map((s) => ({ ...s })),
  };
}

export function _spurenLeeren(): void {
  puffer = [];
}

const alsText = (a: unknown): string => {
  if (a instanceof Error) return `${a.name}: ${a.message}\n${(a.stack ?? "").split("\n").slice(1, 4).join("\n")}`;
  if (typeof a === "string") return a;
  try { return JSON.stringify(a); } catch { return String(a); }
};

export function installiereTicketSpuren(): void {
  if (installiert || typeof window === "undefined") return;
  installiert = true;
  // Telefonie loggt per warn/debug mit Präfix [telephony] — eigener Puffer (T-28).
  installiereTelefonieSpuren();
  const original = console.error.bind(console);
  console.error = (...args: unknown[]) => {
    try {
      merkeSpur("konsole", args.map(alsText).join(" "));
    } catch {
      /* Spuren dürfen Logging nie stören */
    }
    original(...args);
  };
  window.addEventListener("error", (e) => {
    try {
      merkeSpur("konsole", alsText(e.error ?? e.message));
    } catch {
      /* Spuren dürfen Logging nie stören */
    }
  });
  window.addEventListener("unhandledrejection", (e) => {
    try {
      merkeSpur("konsole", `Unhandled: ${alsText((e as PromiseRejectionEvent).reason)}`);
    } catch {
      /* Spuren dürfen Logging nie stören */
    }
  });
}
